import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\GetAuthUserController::__invoke
* @see app/Http/Controllers/User/GetAuthUserController.php
* @route '/api/auth/user'
*/
const GetAuthUserController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAuthUserController.url(options),
    method: 'get',
})

GetAuthUserController.definition = {
    methods: ["get","head"],
    url: '/api/auth/user',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\GetAuthUserController::__invoke
* @see app/Http/Controllers/User/GetAuthUserController.php
* @route '/api/auth/user'
*/
GetAuthUserController.url = (options?: RouteQueryOptions) => {
    return GetAuthUserController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\GetAuthUserController::__invoke
* @see app/Http/Controllers/User/GetAuthUserController.php
* @route '/api/auth/user'
*/
GetAuthUserController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAuthUserController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\GetAuthUserController::__invoke
* @see app/Http/Controllers/User/GetAuthUserController.php
* @route '/api/auth/user'
*/
GetAuthUserController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAuthUserController.url(options),
    method: 'head',
})

export default GetAuthUserController